import ContractRequestList from './List';
import ContractRequestEdit from './Edit';

const ContractRequestLabel = "Contract Request List";

export { ContractRequestList, ContractRequestEdit, ContractRequestLabel };
